import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { TransRecordApi } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
/**
 *
 * 账变记录
 * created by 六月
 * 2022-02-18
 *
 */
export var TransService = /*#__PURE__*/function (_BaseResource) {
  _inherits(TransService, _BaseResource);
  var _super = _createSuper(TransService);
  function TransService() {
    _classCallCheck(this, TransService);
    return _super.apply(this, arguments);
  }
  _createClass(TransService, [{
    key: "billFlow",
    value: function billFlow(params) {
      // 账变记录
      return this.requester.get(TransRecordApi.BillFlow, {
        params
      });
    }
  }, {
    key: "rechargerList",
    value: function rechargerList(params) {
      // 充值记录
      return this.requester.get(TransRecordApi.rechargerList, {
        params
      });
    }
  }, {
    key: "withdrawList",
    value: function withdrawList(params) {
      // 提现记录
      return this.requester.get(TransRecordApi.withdrawList, {
        params
      });
    }
  }, {
    key: "quotaList",
    value: function quotaList(params) {
      // 额度转换记录
      return this.requester.get(TransRecordApi.quotaList, {
        params
      });
    }
  }, {
    key: "tranTypes",
    value: function tranTypes() {
      // 获取账变类型
      return this.requester.get(TransRecordApi.tranTypes);
    }
  }]);
  return TransService;
}(BaseResource);